// 场景数据绑定 API（阶段4｜G3 持久化）
import client from './client';

export interface SceneBindingRecord {
  id: string;
  sceneId: string;
  modelNodeId: string;
  modelNodeName?: string;
  deviceId?: string;
  bindPointKey?: string;
  dataSetId?: string;
  visualType: string;
  ruleConfig: Record<string, unknown>;
  createdAt?: string;
  updatedAt?: string;
}

export function fetchSceneBindings(sceneId: string): Promise<SceneBindingRecord[]> {
  return client.get(`/scenes/${sceneId}/bindings`).then((r) => r.data);
}

export function createSceneBinding(sceneId: string, data: Partial<SceneBindingRecord>): Promise<SceneBindingRecord> {
  return client.post(`/scenes/${sceneId}/bindings`, data).then((r) => r.data);
}

export function updateSceneBinding(sceneId: string, id: string, patch: Partial<SceneBindingRecord>): Promise<SceneBindingRecord> {
  return client.put(`/scenes/${sceneId}/bindings/${id}`, patch).then((r) => r.data);
}

export function removeSceneBinding(sceneId: string, id: string): Promise<void> {
  return client.delete(`/scenes/${sceneId}/bindings/${id}`).then(() => undefined);
}

/** 全量替换（场景保存 flush） */
export function replaceSceneBindings(sceneId: string, items: Partial<SceneBindingRecord>[]): Promise<SceneBindingRecord[]> {
  return client.put(`/scenes/${sceneId}/bindings`, items).then((r) => r.data);
}